import React, { useCallback, useEffect, useRef, useState } from 'react';
import { toJpeg } from 'html-to-image';
import InvoicePage from './components/InvoicePage'
import { Invoice } from './data/types'
import { configData } from "./config/config";

function App() {

  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [download, setDownload] = useState(false);
  const [isActive] = useState({
    is_active: "1"
  });

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    // إضافة event listeners لمراقبة التغييرات في حالة الاتصال بالإنترنت
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // تنظيف event listeners عند إلغاء المكون
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const ref = useRef<HTMLDivElement>(null)

  // const getCheckActivation = async () => {
  //   var url = "https://invoices.creativesdevs.com/app/api/select_by/"
  //   var body = {
  //     table: "activation",
  //     field:"invoice_key",
  //     value:"printer_home"
  //   }
  //   console.log(body)
  //   await axios.post(url,body).then(res=>{
  //     console.log(res.data)
  //     setIsActive(res.data[0])
  //   })
  // }

  // useEffect(()=>{
  //   getCheckActivation()
  // },[])

  const onButtonClick = useCallback(() => {

    setDownload(true);

    if (ref.current === null) {
      return
    }

    toJpeg(ref.current, { quality: 1 })
      .then(function (dataUrl) {
        var link = document.createElement('a');
        link.download = 'اسماعيل الشايب لأعمال الحدادة.jpeg';
        link.href = dataUrl;
        link.click();
        setDownload(false);
      }).catch((err) => {
        setDownload(false);
        console.log(err)
      });

    //
    // toPng(ref.current, { cacheBust: true, quality: 0.3})
    //   .then((dataUrl) => {
    //     const link = document.createElement('a')
    //     link.download = '5FASH-Invoice.png'
    //     link.href = dataUrl
    //     link.click()
    //       setDownload(false);
    //   })
    //   .catch((err) => {
    //       setDownload(false);
    //       console.log(err)
    //   })
  }, [ref])


  let invoiceData;

  const savedInvoice = window.localStorage.getItem('invoiceDataJson')
  if (savedInvoice) {
    invoiceData = savedInvoice
  } else {
    invoiceData = configData;
  }
  let data = null

  try {
    if (invoiceData) {
      data = JSON.parse(invoiceData)
    }
  } catch (_e) { }

  const onInvoiceUpdated = (invoice: Invoice) => {
    window.localStorage.setItem('invoiceDataJson', JSON.stringify(invoice))
  }

  const CallButton = () => {
    window.location.href = 'tel:+918731100';
  };

  return (
    <div className="app">
      {isOnline ? (
        <div>
          {isActive.is_active === "1" ? <div>
            <button onClick={onButtonClick} className={!download ? "invoice-btn-print" : "invoice-btn-print btn-loading"}>
              {!download ? <i className="fa fa-download"></i> : null}
              <div className="btn-text">
                {download ? "... تنزيل" : "تنزيل الفاتورة"}
              </div>
            </button>
            <div className="div-invoice">
              <div ref={ref}>
                <InvoicePage download={download} data={data} onChange={onInvoiceUpdated} />
              </div>
            </div>
          </div> :
            <div className='center bold'>
              حسابك غير نشط
              <br />
              0اتصل على الرقم 918731100
              <br />
              <button className='btn-call' onClick={CallButton}>إجراء مكالمة</button>
            </div>
          }
        </div>
      ) : (
        <div className='center bold'>
          <p style={{ color: "red" }}>أنت غير متصل بالإنترنت</p>
        </div>
      )}
    </div>
  )
}

export default App
